import { cn } from "@/lib/utils";

type SectionProps = {
  title: string;
  children: React.ReactNode;
  gridClassName?: string;
};

const SectionAnalytics = ({
  title,
  children,
  gridClassName = "grid-cols-1 md:grid-cols-2 lg:grid-cols-4",
}: SectionProps) => (
  <>
    <h2 className="text-xl font-semibold text-palomma-secondary">{title}</h2>
    <div className={cn("grid gap-4 md:gap-6", gridClassName)}>{children}</div>
  </>
);

export default SectionAnalytics;
